(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices/player-notifications-checker/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/components/accountservices/player-notifications-checker/assets/javascripts/init.js');

(function(svs) {
  'use strict';

  if (svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
    svs.accountservices.verification_message && svs.accountservices.verification_message.destroy();
    $(function() {
      setTimeout(function() {
        svs.accountservices.player_notifications_checker.checkPlayerNotifications();
      }, 500);
    });
  }
})(svs);


 })(window);